// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__GiZEb","selects":"Documents_selects__1eijQ"};